import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { css } from "styled-components";
import Icon from "~/components-shared/Icon";
import Label from "~/components-shared/Label";
const Wrapper = styled.div`
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  display: flex;
  flex-direction: row;
`;
const StyledIcon = styled(Icon)`
  cursor: pointer;
  margin-top: 0.5rem;
  position: relative;
  z-index: 1;

  &:before {
    content: "";
    position: absolute;
    top: -3px;
    left: -3px;
    width: calc(100% + 6px);
    height: calc(100% + 6px);
    transition: background-color 200ms ease-out;
    background-color: transparent;
    border-radius: 5px;
    z-index: -1;
  }

  ${_ref2 => {
  let {
    $disabled
  } = _ref2;
  return !$disabled && css`
      &:hover:before {
        background-color: ${_ref3 => {
    let {
      theme
    } = _ref3;
    return theme.colors.action.hover;
  }};
      }
    `;
}}
`;
const Outline = styled.div`
  width: ${_ref4 => {
  let {
    $scale,
    theme
  } = _ref4;
  return theme.typography.fontStep * $scale;
}}rem;
  height: ${_ref5 => {
  let {
    $scale,
    theme
  } = _ref5;
  return theme.typography.fontStep * $scale;
}}rem;
  border-radius: ${_ref6 => {
  let {
    $scale
  } = _ref6;
  return $scale * 0.5;
}}px;
  ${_ref7 => {
  let {
    $outline,
    theme
  } = _ref7;
  return theme.shadows.outline(theme, $outline);
}}
`;
const Input = styled.input`
  opacity: 0;
  width: 0;
  position: absolute;
`;
const InputCheckbox = _ref8 => {
  let {
    label,
    value = false,
    error,
    onChange = () => false,
    required = false,
    disabled = false,
    scale = 5,
    color = "primary",
    s,
    children,
    labelProps,
    inputProps,
    outline,
    ...rest
  } = _ref8;
  const handleClick = event => {
    event.stopPropagation();
    if (disabled) {
      return;
    }
    onChange(!value, event);
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $s: s
  }, rest), /*#__PURE__*/React.createElement(Outline, {
    $outline: outline,
    $scale: scale
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    $disabled: disabled,
    scale: scale,
    src: value ? "checkboxFill" : "checkbox",
    onClick: handleClick,
    color: disabled ? "disabled" : color,
    display: "block"
  }), /*#__PURE__*/React.createElement(Input, _extends({
    type: "checkbox",
    disabled: disabled
  }, inputProps))), !!label && /*#__PURE__*/React.createElement(Label, _extends({
    s: {
      mt: 1.5,
      ml: 2,
      mb: 2
    },
    onClick: handleClick,
    required: required,
    disabled: disabled
  }, labelProps), label));
};
export default InputCheckbox;